import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `PanelLeft` — panel-left icon.
 * Aria label:    Panel left
 * Family:        navigation
 * Related:       home, sidebar, panel-right, layout-grid, layout-list, layout-dashboard
 * Canonical use: panel left glyph in navigation UI surfaces.
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Panel left.
 *
 */
export const PanelLeft = forwardRef(function PanelLeft(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("path", { d: "M3 5 h18 a1 1 0 0 1 1 1 v12 a1 1 0 0 1 -1 1 H3 a1 1 0 0 1 -1 -1 V6 a1 1 0 0 1 1 -1 z" }), _jsx("path", { d: "M9 5 v14" })] }));
});
//# sourceMappingURL=panel-left.js.map